import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M163.9 10H36.1c-8.6 0-15.6 7-15.6 15.6v153.3c0 4.9 5.8 7.5 9.4 4.2l11.1-10c2.2-2 5.5-1.9 7.6.1l16.3 15.2c1.9 1.8 4.9 2 7.1.5l24.8-17.1c1.9-1.3 4.5-1.3 6.4 0l24.9 17.1c2.2 1.5 5.1 1.3 7-.5l16.5-15.2c2.1-2 5.4-2 7.6 0L170 183c3.6 3.3 9.4.7 9.4-4.2V25.6c.1-8.6-6.9-15.6-15.5-15.6zM36.4 48.6c0-4.4 3.6-8 8-8h47.9c4.4 0 8 3.6 8 8s-3.6 8-8 8H44.4c-4.4 0-8-3.6-8-8zm79.5 31.9c0 4.4-3.6 8-8 8H44.4c-4.4 0-8-3.6-8-8s3.6-8 8-8H108c4.4 0 7.9 3.6 7.9 8z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}